module.exports = __webpack_public_path__ + "img/a9z29-wbe0y.f9f94a49.png";